(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
(function () {
  var panel = document.getElementById('m-nav');
  var overlay = document.querySelector('.mnav-overlay');
  if (!panel || !overlay) return;
  var opener = document.querySelector('[data-mnav-open]');
  var lastFocus = null;

  function open() {
    lastFocus = document.activeElement;
    panel.hidden = false;
    overlay.hidden = false;
    document.body.classList.add('mnav-lock');
    if (opener) opener.setAttribute('aria-expanded', 'true');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        panel.setAttribute('data-state', 'open');
        overlay.setAttribute('data-state', 'open');
      });
    });
    var first = panel.querySelector('.mnav__close');
    if (first) first.focus();
  }

  function close() {
    panel.removeAttribute('data-state');
    overlay.removeAttribute('data-state');
    document.body.classList.remove('mnav-lock');
    if (opener) opener.setAttribute('aria-expanded', 'false');
    window.setTimeout(function () {
      panel.hidden = true;
      overlay.hidden = true;
    }, 300);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-mnav-open]')) { e.preventDefault(); open(); return; }
    if (e.target.closest('[data-mnav-close]')) { e.preventDefault(); close(); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !panel.hidden) close();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offers"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.getElementById('offers');
  if (!root) return;
  var copied = root.getAttribute('data-copied') || 'Copied';
  root.addEventListener('click', function (e) {
    var btn = e.target.closest('.offer__code');
    if (!btn) return;
    var code = btn.getAttribute('data-code') || '';
    var lbl = btn.querySelector('.offer__code-lbl');
    var original = btn.getAttribute('data-orig') || (lbl ? lbl.textContent : '');
    btn.setAttribute('data-orig', original);
    function done() {
      btn.setAttribute('data-copied', 'true');
      if (lbl) lbl.textContent = copied;
      clearTimeout(btn._t);
      btn._t = setTimeout(function () {
        btn.removeAttribute('data-copied');
        if (lbl) lbl.textContent = original;
      }, 2000);
    }
    function fallback() {
      var ta = document.createElement('textarea');
      ta.value = code;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); done(); } catch (err) {}
      document.body.removeChild(ta);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done).catch(fallback);
    } else {
      fallback();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-banner"] && !Shopify.designMode) return;
  try {
    
(function () {
  var roots = document.querySelectorAll('[data-story]');
  if (!roots.length) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  Array.prototype.forEach.call(roots, function (root) {
    var slides = root.querySelectorAll('.story__slide');
    if (!slides.length) return;
    var i = 0;
    var timer = null;
    var ms = (parseFloat(root.getAttribute('data-interval')) || 3) * 1000;

    slides[0].setAttribute('data-active', '');
    root.setAttribute('data-index', '0');

    function show(n) {
      slides[i].removeAttribute('data-active');
      i = (n + slides.length) % slides.length;
      slides[i].setAttribute('data-active', '');
      root.setAttribute('data-index', String(i));
    }

    function start() { if (timer || slides.length < 2) return; timer = window.setInterval(function () { show(i + 1); }, ms); }
    function stop() { if (timer) { window.clearInterval(timer); timer = null; } }

    // Autoplay starts straight away. The observer below only pauses it
    // while the banner is scrolled out of view. Starting inside the
    // observer instead would freeze the banner on slide one anywhere its
    // callback never runs.
    start();

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { start(); } else { stop(); } });
      }, { threshold: 0.15 }).observe(root);
    }

    if (reduce) return;

    // Parallax: shift the image layer against the page scroll, clamped so
    // it can never travel further than the 7% overscan above and below.
    var wraps = root.querySelectorAll('.story__imgwrap');
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        var r = root.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        var p = (r.top + r.height / 2 - window.innerHeight / 2) / window.innerHeight;
        if (p > 1) { p = 1; } else if (p < -1) { p = -1; }
        var y = (p * -30).toFixed(1);
        for (var k = 0; k < wraps.length; k++) {
          wraps[k].style.transform = 'translate3d(0,' + y + 'px,0)';
        }
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
